/**
 * COMMON
 *
 * @date 2022-03-24
 */


(function ($) {
  const COMMON = window.COMMON || {};

  COMMON.index = function () {
    // 初期化
    const _init = function () {
      topKvCarousel();
      topContentsCarousel();
      $(window).on('resize', topContentsCarousel);
      blogCarousel();
      $(window).on('resize', blogCarousel);
      lineupCarousel();
      $(window).on('resize', lineupCarousel);
      onlineTopCarousel();
      onlineLinkSlider();
      $(window).on('scroll load', setHeaderHidden);
      toggleScrollLock();
      if (window.matchMedia('(max-width: 768px)').matches) {
        setviewPortHeight.init();
      }
      openingAnimation.init();
    };

    const openingAnimation = function () {
      const $openingAnimationTarget = $('.template-index');

      const _init = function () {
        _bind();
      };

      const _bind = function () {
        $(window).on('load', addOpeningClass);
      };

      const addOpeningClass = () => {
        setTimeout(() => {
          $openingAnimationTarget.addClass('is_opening');
        }, 300);
      };

      return {
        init: _init
      };
    }();

    const setviewPortHeight = function () {

      const $viewPortHeightTarget = $('.js_viewportHeight');

      const _init = function () {
        _bind();
      };

      const _bind = function () {
        viewPortHeight();
        $(window).on('resize', viewPortHeight);
      };

      const viewPortHeight = () => {
        const $windowHeight = $(window).height();
        $viewPortHeightTarget.css('max-height', $windowHeight);
      };

      return {
        init: _init
      };
    }();

    const topKvCarousel = () => {
      const $carousel = $('.js_topKvSlider');
      if (!$carousel.length) return;

        $carousel.on('touchmove', function (event, slick, currentSlide, nextSlide) {
          $carousel.slick('slickPlay');
        });
        $carousel.not('.slick-initialized').each(function (index) {

          $carousel.eq(index).slick({
            arrows: false,
            infinite: true,
            slidesToShow: 1,
            dots: true,
            pauseOnFocus: false,
            pauseOnHover: false,
            pauseOnDotsHover: false,
            speed: 3000,
            autoplaySpeed: 6000,
            autoplay: true,
            fade: true,
            responsive: [
              {
                breakpoint: 768, // 〜767px
                settings: {
                  swipeToSlide: true,
                  outerEdgeLimit: true,
                }
              }
            ],
          }).on('beforeChange', function (event, slick, currentSlide) {
            var $slidebase = $(this).parents();
            $slidebase.find('.slick-slide').removeClass('slick-continue');
            $slidebase.find('.slick-active').addClass('slick-continue');
          });
        });
    };

    const topContentsCarousel = () => {
      const $carousel = $('.js_contentsSlider');
      if (!$carousel.length) return;
      if (window.matchMedia('(min-width: 768px)').matches) {
        $('.js_contentsSlider.slick-initialized').slick('unslick');
        return;
      } else {
        $carousel.not('.slick-initialized').each(function (index) {

          $carousel.eq(index).slick({
            responsive: [
              {
                breakpoint: 768, // 〜767px
                settings: {
                  centerPadding: '24.15%',
                  slidesToShow: 1,
                  arrows: false,
                  centerMode: false,
                  infinite: false,
                  swipeToSlide: true,
                  variableWidth: true,
                  outerEdgeLimit: true,
                }
              }
            ],
          });
        });
      }
    };

    const blogCarousel = () => {
      const $carousel = $('.js_blogSlider');
      if (!$carousel.length) return;
      if (window.matchMedia('(min-width: 768px)').matches) {
        $('.js_blogSlider.slick-initialized').slick('unslick');
        return;
      } else {
        $carousel.not('.slick-initialized').each(function (index) {

          $carousel.eq(index).slick({
            responsive: [
              {
                breakpoint: 768, // 〜767px
                settings: {
                  centerPadding: '24.15%',
                  slidesToShow: 1,
                  arrows: false,
                  dots: true,
                  centerMode: false,
                  infinite: false,
                  swipeToSlide: true,
                  variableWidth: true,
                  outerEdgeLimit: true,
                }
              }
            ],
          });
        });
      }
    };

    const lineupCarousel = () => {
      const $carousel = $('.js_lineupSlider');
      if (!$carousel.length) return;
      if (window.matchMedia('(min-width: 768px)').matches) {
        $('.js_lineupSlider.slick-initialized').slick('unslick');
        return;
      } else {
        $carousel.not('.slick-initialized').each(function (index) {

          $carousel.eq(index).slick({
            responsive: [
              {
                breakpoint: 768, // 〜767px
                settings: {
                  centerPadding: '24.15%',
                  slidesToShow: 1,
                  arrows: false,
                  dots: false,
                  centerMode: false,
                  infinite: false,
                  swipeToSlide: true,
                  variableWidth: true,
                  outerEdgeLimit: true,
                }
              }
            ],
          });
        });
      }
    };

    const onlineTopCarousel = () => {
      const $carousel = $('.js_onlineTopSlider');
      if (!$carousel.length) return;

      $carousel.on('touchmove', function (event, slick, currentSlide, nextSlide) {
        $carousel.slick('slickPlay');
      });
      $carousel.not('.slick-initialized').each(function (index) {

        $carousel.eq(index).slick({
          arrows: false,
          infinite: true,
          slidesToShow: 1,
          centerMode: true,
          dots: true,
          pauseOnFocus: false,
          pauseOnHover: false,
          pauseOnDotsHover: false,
          speed: 1300,
          autoplaySpeed: 6000,
          autoplay: true,
          cssEase: 'cubic-bezier(.25, .46, .45, .94)',
          responsive: [
            {
              breakpoint: 768, // 〜767px
              settings: {
                centerMode: false,
                swipeToSlide: true,
                outerEdgeLimit: true,
              }
            }
          ],
        });
      });

      $carousel.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
        $carousel.find('.slick-slide').each((index, el) => {
          const $this = $(el),
            slickindex = $this.attr('data-slick-index');
          if (nextSlide == slick.slideCount - 1 && currentSlide == 0) {
            if (slickindex == '-1') {
              $this.addClass('is_activeSlider');
            } else {
              $this.removeClass('is_activeSlider');
            }
          } else if (nextSlide == 0) {
            if (slickindex == slick.slideCount) {
              $this.addClass('is_activeSlider');
            } else {
              $this.removeClass('is_activeSlider');
            }
          } else {
            $this.removeClass('is_activeSlider');
          }
        });
      });
    };

    const onlineLinkSlider = () => {
      const $sliders = $('.js_onlineLinkSlider');
      if (!$sliders.length) return;

      $sliders.not('.slick-initialized').each(function () {
        $(this).slick({
          dots: true,
          arrows: true,
          infinite: true,
          slidesToShow: 1,
          autoplay: false,
          speed: 600,
          cssEase: 'cubic-bezier(.25, .46, .45, .94)',
        });
      });
    };

    const setHeaderHidden = () => {
      const $header = $('.pageheader');
      const $checkFooter = $('.pagefooter').offset().top - 300;
      if ($(window).scrollTop() > $checkFooter) {
        $('body').addClass('is_headerHidden');
        $header.fadeOut(300);
      } else {
        $('body').removeClass('is_headerHidden');
        $header.fadeIn(300);
      }
    };

    const toggleScrollLock = () => {
      const $scrollbar_width = window.innerWidth - document.body.scrollWidth;
      const $drawerOpenBtn = $('.js_drawerOpenBtn');
      const $drawerCloseBtn = $('.js_drawerCloseBtn');
      if (!$scrollbar_width) return;

      $drawerOpenBtn.click(function(){
        $('body').css('padding-right', $scrollbar_width);
      });
      $drawerCloseBtn.click(function(){
        $('body').css('padding-right', '');
      });
    };


    return {
      init: _init
    };
  }();

  COMMON.index.init();
})(jQuery);
